import {TranslateResult} from "vue-i18n";
import i18n from "@/i18n/i18n.config";

class PageTitleService {
    private readonly plBaseTitle = 'Jachtyuzywane.com - PHU Miron - Jachty używane na sprzedaż';
    private readonly enBaseTitle = 'Jachtyuzywane.com - PHU Miron - Used yachts for sale';

    public setBaseTitle() {
        document.title = this.getBaseTitle();
    }

    public setTitle(prefix: string | TranslateResult) {
        document.title = prefix + ' / ' + this.getBaseTitle();
    }

    private getBaseTitle(): string {
        return i18n.locale === 'pl' ? this.plBaseTitle : this.enBaseTitle;
    }
}

export const pageTitle = new PageTitleService();
